/* @generated */

// src/assets/ui-icon/line/rewind.tsx
import * as React from "react";
var RewindLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 13V8h-1.5v3.5h-2V13H13Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.75 4c-2.922 0-4.982.793-6.25 2.414V4.5H4V9h4.5V7.5H6.578c.974-1.354 2.639-2 5.172-2 4.323 0 6.25 1.928 6.25 6.25 0 4.323-1.927 6.25-6.25 6.25-2.38 0-4.016-.577-5.004-1.764l-1.153.959c1.29 1.551 3.305 2.305 6.157 2.305 5.215 0 7.75-2.535 7.75-7.75S16.965 4 11.75 4Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  RewindLine
};
